import ApiStore from './ApiStore';
import AuthStore from './AuthStore';
import GeneralSettingStore from './GeneralSettingStore';
import ModalStore from './ModalStore';
import UIStore from './UIStore';
import UserStore from './UserStore';
import ShopStore from './ShopStore';
import GeneralStore from './GeneralStore';
import FileStore from './FileStore';
import AppointmentStore from './AppointmentStore';
import { action, makeAutoObservable } from 'mobx';
import ReviewStore from './ReviewStore';
import TopicStore from './TopicStore';
import NotificationStore from './NotificationStore';
import DashboardStore from './DashboardStore';
import PromotionStore from './PromotionStore';
import ReferralCodeStore from './ReferralCodeStore';
import NewsStore from './NewsStore';

export default class RootStore {
    modalStore: ModalStore;
    apiStore: ApiStore;
    uiStore: UIStore;
    authStore: AuthStore;
    userStore: UserStore;
    shopStore: ShopStore;
    generalStore: GeneralStore;
    generalSettingStore: GeneralSettingStore;
    fileStore: FileStore;
    appointmentStore: AppointmentStore;
    reviewStore: ReviewStore;
    topicStore: TopicStore;
    notificationStore: NotificationStore;
    dashboardStore: DashboardStore;
    promotionStore: PromotionStore;
    referralCodeStore: ReferralCodeStore;
    newsStore: NewsStore;

    constructor() {
        makeAutoObservable(this, {
            clearAllStore: action.bound
        });
        this.modalStore = new ModalStore();
        this.apiStore = new ApiStore(this);
        this.uiStore = new UIStore(this);
        this.authStore = new AuthStore(this);
        this.userStore = new UserStore(this);
        this.shopStore = new ShopStore(this);
        this.generalStore = new GeneralStore(this);
        this.generalSettingStore = new GeneralSettingStore(this);
        this.fileStore = new FileStore(this);
        this.appointmentStore = new AppointmentStore(this);
        this.reviewStore = new ReviewStore(this);
        this.topicStore = new TopicStore(this);
        this.notificationStore = new NotificationStore(this);
        this.dashboardStore = new DashboardStore(this);
        this.promotionStore = new PromotionStore(this);
        this.referralCodeStore = new ReferralCodeStore(this);
        this.newsStore = new NewsStore(this);
    }

    clearAllStore() {
        this.userStore.clean();
        this.shopStore.clean();
        this.reviewStore.clean();
        this.appointmentStore.clean();
        this.notificationStore.clean();
        this.topicStore.clean();
        this.dashboardStore.clean();
        this.promotionStore.clean();
        this.referralCodeStore.clean();
        this.newsStore.clean();
    }
}
